module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img23.4f4b3b1e.jpg";